var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cc-preview-module',{attrs:{"title":"变更担保审核信息","data":_vm.displayData,"empty-text":"您提交的申请正在审核中，请您耐心等待。"}})}
var staticRenderFns = []

export { render, staticRenderFns }